import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { Product, ProductListData } from '../../../../features/ambassador-monitoring-tasks/models/ProductListData';
import { TaskPriceForm } from '../../../../features/ambassador-monitoring-tasks/models/TaskPriceForm';
import Swal from 'sweetalert2';
import { MonitorTaskService } from '../../../services/monitor-task.service';

export interface DialogData {
  taskId: number,
  monitorTaskProductId: number
}
@Component({
  selector: 'app-monitor-price-form',
  standalone: false,
  templateUrl: './monitor-price-form.component.html'
})
export class MonitorPriceFormComponent extends DirtyComponent implements OnInit, AfterViewInit {
  override formGroup: FormGroup = new FormGroup({});

  loading = false;
  isLoading = false;
  dataLoading = false;
  isSubmitted = false;
  filesChanged = false;
  isUpdate!: boolean;
  products: Product[] = [];

  files: any[] = []
  deletedFiles: any[] = []

  filterModel: any = {
    pageIndex: 0,
    pageSize: 10,
    taskId: 0,
    monitorTaskProductId: 0
  }

  pageIndex = 0;
  pageSize = 10;
  totalProductsCount = 0;
  selectedIndex = 0;
  @ViewChild('stripContainer') stripContainer!: ElementRef<HTMLDivElement>;
  @ViewChildren('thumbItem') thumbItems!: QueryList<ElementRef<HTMLDivElement>>;


  constructor(override dialogRef: MatDialogRef<MonitorPriceFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    translate: TranslateService,
    private el: ElementRef,
    private service: MonitorTaskService,
    private swalService: SwalService) {
    super(translate)
  }

  ngOnInit(): void {
    this.buildForm()
    const initialIndex = this.products.findIndex(p => p.isSelected);
    this.selectedIndex = initialIndex >= 0 ? initialIndex : 0;
    this.dataLoading = true;
    this.loadNextPage(true);
  }

  ngAfterViewInit(): void {
    // this.scrollToSelected();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      productNotFound: [false],
      currentPrice: [],
      isPromotionalOffer: [false],
      productPriceBeforePromotion: [],
    })
  }

bindDataToForm() {
  this.formGroup.patchValue({
    productNotFound: this.selectedProductCard?.productNotFound,
    currentPrice: this.selectedProductCard?.monitorPrice,
    isPromotionalOffer: this.selectedProductCard?.isPromotionalOffer,
    productPriceBeforePromotion: this.selectedProductCard?.productPriceBeforePromotion,
  });

  this.handelChange();
  this.files = this.selectedProductCard?.attachments || [];
  this.filesChanged = false;
  this.isSubmitted = false;

   this.formGroup.markAsUntouched();
  this.formGroup.markAsPristine();

   Object.keys(this.formGroup.controls).forEach(key => {
    this.formGroup.get(key)?.setErrors(null);
    this.formGroup.get(key)?.markAsUntouched();
    this.formGroup.get(key)?.markAsPristine();
  });

  this.formGroup.updateValueAndValidity();
}

  loadNextPage(isInitialLoad: boolean = false) {
    if (this.isLoading) return;
    if (this.products.length >= this.totalProductsCount && this.totalProductsCount > 0) return;

    this.isLoading = true;
    this.filterModel.pageIndex = this.pageIndex;
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.taskId = this.data.taskId;
    this.filterModel.monitorTaskProductId = this.data.monitorTaskProductId;
    this.service.getMonitorTaskPriceScreen(this.filterModel)
      .subscribe((res: any) => {
        this.products = [...this.products, ...res.products];
        this.totalProductsCount = res.totalProductsCount;
        if (isInitialLoad) {
          this.selectInitialProduct();
        }
        this.pageIndex++;
        this.isLoading = false;
        this.dataLoading = false;
      }, error => {
        this.isLoading = false;
        this.dataLoading = false;
        this.handleErrors(error.detail);
      });
  }

  selectInitialProduct(): void {
    const initialIndex = this.products.findIndex(p => p.monitorTaskProductId === this.data.monitorTaskProductId);
    this.selectedIndex = initialIndex >= 0 ? initialIndex : 0;

    this.bindDataToForm();
    setTimeout(() => this.scrollToSelected());
  }

  selectProduct(index: number) {

    const hasUnsavedChanges = this.formGroup.dirty || this.filesChanged;

    if (!hasUnsavedChanges) {
      this.navigateToProduct(index);
      return;
    }

    Swal.fire({
      title: this.translate.instant('monitoringTasks.continueWithoutSavingTitle'),
      text: this.leaveMsg || this.translate.instant('monitoringTasks.continueWithoutSavingMessage'),
      imageUrl: './assets/images/icons/warning-ic.svg',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('monitoringTasks.continue'),
      cancelButtonText: this.translate.instant('swalMsg.No'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.selectedProductCard.attachments = []
        this.files = []
        this.navigateToProduct(index);
      }
    });
  }

  navigateToProduct(index: number): void {
    this.selectedIndex = index;
    this.bindDataToForm();

    if (index >= this.products.length - 3) {
      this.loadNextPage();
    }

    this.scrollToSelected();
  }

  goNext() {
    if (this.selectedIndex < this.products.length - 1) {
      this.selectProduct(this.selectedIndex + 1);
    }
  }

  goPrev() {
    if (this.selectedIndex > 0) {
      this.selectProduct(this.selectedIndex - 1);
    }
  }


  get selectedProductCard() {
    return this.products[this.selectedIndex];
  }


  get currentProductNumber() {
    return this.selectedIndex + 1;
  }

  onStripScroll(event: Event) {
    const el = event.target as HTMLElement;
    const nearEnd = el.scrollWidth - (el.scrollLeft + el.clientWidth) < 200;
    if (nearEnd) {
      this.loadNextPage();
    }
  }

  private scrollToSelected(): void {
    setTimeout(() => {
      const items = this.thumbItems?.toArray();
      const target = items?.[this.selectedIndex]?.nativeElement;

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    });
  }

  handelChange() {
    if (this.formGroup.get('productNotFound')?.value) {
      this.formGroup.get('currentPrice')?.setValue(null);
      this.formGroup.get('currentPrice')?.disable();
    } else { this.formGroup.get('currentPrice')?.enable(); }
  }

  handelPromotionalOfferChange(event: any) {
    if (!event.checked) {
      this.formGroup.get('productPriceBeforePromotion')?.setValue(null);
    }
  }

  onFilesSelected(files: any[]) {
    this.files = files;
    this.filesChanged = true;
  }

  onFilesDeleted(deleted: any[]) {
    this.deletedFiles = deleted;
    if (deleted.length) {
      this.filesChanged = true;
    }
  }

  saveRecord(isClose: boolean = false) {
    this.isSubmitted = true;
    if (this.isRequired() && !this.files.length) {
      setTimeout(() => {
        const fileManagerEl: HTMLElement = this.el.nativeElement.querySelector('app-file-manager');
        fileManagerEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return;
    }
    if (this.formGroup.valid) {
      this.loading = true;
      let data: TaskPriceForm = this.formGroup.value;
      let title = data.productNotFound ? this.translate.instant('monitoringTasks.productMarkedAsNotFoundSuccessfully') : this.translate.instant('monitoringTasks.priceMonitoringDataSavedSuccessfully');
      data.monitorTaskId = this.data.taskId;
      data.monitorTaskProductId = this.selectedProductCard.monitorTaskProductId;
      data.deletedAttachmentsIds = this.deletedFiles;
      const formData = new FormData();
      this.files.forEach(file => {
        if (file.id === undefined) {
          formData.append('attchments_' + data.monitorTaskProductId, file, file.name);
        }
      });
      formData.append('data', JSON.stringify(data));

      this.service.submitMonitorTaskPrice(formData).subscribe(
        (res: any) => {
          this.loading = false;
          Swal.fire({
            title: title,
            imageUrl: './assets/images/icons/success.svg',
            confirmButtonText: this.translate.instant('swalMsg.Ok'),
          });
          this.filesChanged = false;
          this.formGroup.markAsUntouched();
          this.formGroup.markAsPristine();
          this.formGroup.updateValueAndValidity();
          this.products[this.selectedIndex] = res;
          if (isClose) {
            this.dialogRef.close(true);
          } else {
            this.service.refreshDetails.next(true);
            this.service.refreshProducts.next(true);
            if (this.selectedIndex < this.products.length - 1) {
              this.goNext()
            }
          }
        },
        (error: any) => {
          this.loading = false;
          this.handleErrors(error.detail);
        }
      );
    } else {
      this.formGroup.markAllAsTouched();
      this.scrollToFirstInvalidControl();
    }
  }

isRequired(): boolean {
  const priceControl = this.formGroup.get('currentPrice');
  const value = priceControl?.value;

  if (value === null || value === undefined || value === '' || this.formGroup.get('productNotFound')?.value) {
    return false;
  }

  const numericValue = Number(value);
  const lowPrice = Number(this.selectedProductCard?.lowPrice ?? 0);
  const highPrice = Number(this.selectedProductCard?.highPrice ?? Infinity);

  return numericValue < lowPrice || numericValue > highPrice;
}


  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    );
    firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }


  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}
